export default __webpack_public_path__ + "static/popinato@2x-7602bd02116441a533af68591cebdd14.png";